import { render, staticRenderFns } from "./designs.vue?vue&type=template&id=1a2eadd7&scoped=true"
import script from "./designs.vue?vue&type=script&lang=js"
export * from "./designs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2eadd7",
  null
  
)

export default component.exports